import {
  PREVENTIEF_ONDERHOUD_LOADING,
  PREVENTIEF_ONDERHOUD_ERROR,
  ONDERHOUDSTAKEN_SUCCESS,
  ONDERHOUDSTAAK_DETAIL_SUCCESS,
  ONDERHOUDSTAAK_CREATE_SUCCESS,
  ONDERHOUDSTAAK_UPDATE_SUCCESS,
  ONDERHOUDSTAAK_DELETE_SUCCESS,
  ONDERHOUDSTAKEN_STATISTICS_SUCCESS,
  PLANNING_SUCCESS,
  PLANNING_DETAIL_SUCCESS,
  PLANNING_CREATE_SUCCESS,
  PLANNING_UPDATE_SUCCESS,
  PLANNING_DASHBOARD_SUCCESS,
  COMPLIANCE_SUCCESS,
  COMPLIANCE_DETAIL_SUCCESS,
  COMPLIANCE_CREATE_SUCCESS,
  COMPLIANCE_UPDATE_SUCCESS,
  COMPLIANCE_DASHBOARD_SUCCESS,
  VOORRAAD_SUCCESS,
  VOORRAAD_DETAIL_SUCCESS,
  VOORRAAD_CREATE_SUCCESS,
  VOORRAAD_UPDATE_SUCCESS,
  VOORRAAD_STATISTICS_SUCCESS,
  VOORRAAD_LOW_STOCK_SUCCESS
} from './actions';

const initialState = {
  loading: false,
  error: null,
  
  // Onderhoudstaken
  onderhoudstaken: [],
  onderhoudstaak: null,
  onderhoudstakenStatistics: null,
  
  // Planning
  planning: [],
  planningItem: null,
  planningDashboard: null,
  
  // Compliance
  compliance: [],
  complianceItem: null,
  complianceDashboard: null,
  
  // Voorraad
  voorraad: [],
  voorraadItem: null,
  voorraadStatistics: null,
  lowStockItems: []
};

export default function preventiefOnderhoudReducer(state = initialState, action) {
  switch (action.type) {
    case PREVENTIEF_ONDERHOUD_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };

    case PREVENTIEF_ONDERHOUD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    // ===========================================
    // ONDERHOUDSTAKEN REDUCERS
    // ===========================================
    
    case ONDERHOUDSTAKEN_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        onderhoudstaken: action.payload
      };

    case ONDERHOUDSTAAK_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        onderhoudstaak: action.payload
      };

    case ONDERHOUDSTAAK_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        onderhoudstaken: [...state.onderhoudstaken, action.payload]
      };

    case ONDERHOUDSTAAK_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        onderhoudstaken: state.onderhoudstaken.map(taak =>
          taak._id === action.payload._id ? action.payload : taak
        ),
        onderhoudstaak: action.payload
      };

    case ONDERHOUDSTAAK_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        onderhoudstaken: state.onderhoudstaken.filter(taak => taak._id !== action.payload)
      };

    case ONDERHOUDSTAKEN_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        onderhoudstakenStatistics: action.payload
      };

    // ===========================================
    // PLANNING REDUCERS
    // ===========================================
    
    case PLANNING_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        planning: action.payload
      };

    case PLANNING_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        planningItem: action.payload
      };

    case PLANNING_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        planning: [...state.planning, action.payload]
      };

    case PLANNING_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        planning: state.planning.map(item =>
          item._id === action.payload._id ? action.payload : item
        ),
        planningItem: action.payload
      };

    case PLANNING_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        planningDashboard: action.payload
      };

    // ===========================================
    // COMPLIANCE REDUCERS
    // ===========================================
    
    case COMPLIANCE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        compliance: action.payload
      };

    case COMPLIANCE_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        complianceItem: action.payload
      };

    case COMPLIANCE_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        compliance: [...state.compliance, action.payload]
      };

    case COMPLIANCE_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        compliance: state.compliance.map(item =>
          item._id === action.payload._id ? action.payload : item
        ),
        complianceItem: action.payload
      };

    case COMPLIANCE_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        complianceDashboard: action.payload
      };

    // ===========================================
    // VOORRAAD REDUCERS
    // ===========================================
    
    case VOORRAAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        voorraad: action.payload
      };

    case VOORRAAD_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        voorraadItem: action.payload
      };

    case VOORRAAD_CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        voorraad: [...state.voorraad, action.payload]
      };

    case VOORRAAD_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        voorraad: state.voorraad.map(item =>
          item._id === action.payload._id ? action.payload : item
        ),
        voorraadItem: action.payload
      };

    case VOORRAAD_STATISTICS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        voorraadStatistics: action.payload
      };

    case VOORRAAD_LOW_STOCK_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        lowStockItems: action.payload
      };

    default:
      return state;
  }
}